import { AnimatedComponent } from 'sane-ui'
import Flickity from 'flickity'
import gsap from 'gsap'
import arrowShape from '../config/flickiyArrowShape.json'
import logosPerGroup from '../config/logosPerGroup.json'

class Logos extends AnimatedComponent {
  constructor ($el, args) {
    super($el, args)
    this.$slider = this.$el.find('.logos__slider')
    this.slider = null
    this.logosMarkup = this.$slider.html()
    this.$logos = this.$el.find('.logos__item')
    this.bpHelpers = args.bpHelpers
    this.logosPerGroup = this.$el.is('.logos--compact') ? logosPerGroup.compact : logosPerGroup.large
    this.isInit = false
    this.autoPlay = this.$el.data('autoPlay')

    this.scrollCallback = this.scrollCallback.bind(this)
    this.initSlider = this.initSlider.bind(this)

    $(window)
      .trigger('resize')
      .on('breakpointChange', this.initSlider)
    this.initSlider()

    if (window.innerWidth < 768) {
      this.scheduleAdvance()
    }
  }

  initSlider () {
    if (this.slider) {
      this.slider.destroy()
      this.slider = null
    }

    this.wrapLogos()

    if (this.$slider.find('.logos__slide').length < 2) {
      return
    }

    this.slider = new Flickity(
      this.$slider.get(0),
      {
        wrapAround: true,
        arrowShape,
        on: {
          change: () => { this.scheduleAdvance() },
        },
      }
    )

    this.slider.on('scroll', this.scrollCallback)

    this.isInit = true
  }

  wrapLogos () {
    if (this.isInit) {
      this.$slider
        .empty()
        .append(this.logosMarkup)

      this.$logos = this.$el.find('.logos__item')
    }

    const groupSize = this.logosPerGroup[this.bpHelpers.currentScreen.breakpoint]

    if (groupSize === false) {
      this.$logos
        .wrapAll('<div class="logos__slide"><div class="logos__slide__inner"></div></div>')

      return
    }

    for (let index = 0; index < this.$logos.length; index += groupSize) {
      this.$logos
        .slice(index, index + groupSize)
        .wrapAll('<div class="logos__slide"><div class="row"><div class="col-12 offset-xl-1 col-xl-10"><div class="logos__slide__inner"></div></div></div></div>')
    }
  }

  scrollCallback () {
    this.slider.slides.forEach((slide) => {
      const slideX = (slide.target + this.slider.x) / slide.outerWidth
      const opacity = Math.min(Math.max(1 - Math.abs(slideX) * 2, 0), 1)
      gsap.set($(slide.cells[0].element), { opacity })
    })
  }

  buildTimelineIn () {
    this.timelineIn
      .set(this.$el, { autoAlpha: 1 })
      .from(this.$el.find('.logos__item'), { duration: 1, opacity: 0, ease: 'none', stagger: 0.05 })
      .call(() => { this.scheduleAdvance() })
  }

  scheduleAdvance () {
    if (!this.autoPlay) {
      return
    }

    if (this.autoPlayTimeout !== undefined) {
      clearTimeout(this.autoPlayTimeout)
    }

    if (this.slider !== null) {
      this.autoPlayTimeout = setTimeout(() => {
        this.slider.next()
      }, this.autoPlay * 1000)
    }
  }

  destroy () {
    if (this.autoPlayTimeout !== undefined) {
      clearTimeout(this.autoPlayTimeout)
    }
  }
}

export default Logos



// WEBPACK FOOTER //
// ./scripts/components/Logos.js